export const RESULT_BY_PAGE = 3;
export const HIGHLIGHT = '<mark class="bg-yellow-51 font-bold"></mark>';
export const DEBOUNCE_TIMEOUT = 500;

export interface SearchResult {
  id: string;
  type: string;
  title: string;
  body_excerpt: string;
  url: string;
  score: number;
  highlight: {
    title?: string[] | null;
    body?: string[] | null;
  };
}

export const LABEL = {
  fr: 'Rechercher un article',
  en: 'Search articles',
  es: 'Buscar un artículo',
};

export const NO_ITEM = (query: string) => ({
  fr: `Désolé, nous n'avons rien trouvé pour "${query}"`,
  en: `We're sorry, we cannot find any matches for "${query}"`,
  es: `Lo sentimos, no encontramos resultados para "${query}"`,
});

export function highlightMatches(string: any, highlight: any): string {
  return string.replace(/\[h\](.+?)\[\/h\]/g, function (a: any, b: any) {
    const div: any = document.createElement('div');

    div.innerHTML = highlight;
    div.children[0]['innerText'] = b;

    return div.children[0].outerHTML;
  });
}
